import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslationApp } from "../../lib/i18next";
import TitlePage from "../Texts/TitlePage";
import { usePlanType, getPricingHeroTitle } from "./plansConfiguration";
import {
  PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION,
  PRICING_APPSUMO_CREDITS_STACK_TITLE,
} from "../../i18n/keysTranslations";
import { PRICING_CARD_WIDTH } from "./PricingCard";
import {
  GRAY_COLOR_TEXT_DISABLED,
  RECURRENT_BADGE_MONTHLY_BG_COLOR,
  RECURRENT_BADGE_MONTHLY_BORDER_COLOR,
  RECURRENT_BADGE_MONTHLY_TEXT_COLOR,
} from "../../utils/colors";

/** Matches `Grid spacing={2}` between pricing cards. */
const PRICING_CARD_GAP = 16;

const getCardRowWidth = (planCount) =>
  planCount * PRICING_CARD_WIDTH +
  Math.max(planCount - 1, 0) * PRICING_CARD_GAP;

const AppSumoCreditsStackBanner = ({ t, planCount }) => (
  <Box
    sx={{
      mt: 2.5,
      width: { xs: "100%", sm: getCardRowWidth(planCount) },
      maxWidth: "100%",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: 0.25,
      px: 2,
      py: 1.5,
      borderRadius: "12px",
      backgroundColor: RECURRENT_BADGE_MONTHLY_BG_COLOR,
      border: `1px solid ${RECURRENT_BADGE_MONTHLY_BORDER_COLOR}`,
    }}
  >
    <InfoOutlinedIcon
      sx={{
        fontSize: 18,
        color: RECURRENT_BADGE_MONTHLY_TEXT_COLOR,
        mb: 0.25,
      }}
    />
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.95rem",
        lineHeight: 1.3,
        color: "background.paperContrastText",
      }}
    >
      {t(PRICING_APPSUMO_CREDITS_STACK_TITLE)}
    </Typography>
    <Typography
      sx={{
        fontSize: "0.8125rem",
        lineHeight: 1.45,
        color: GRAY_COLOR_TEXT_DISABLED,
      }}
    >
      {t(PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION)}
    </Typography>
  </Box>
);

const PricingHero = ({
  showAppSumoCreditsBanner = false,
  appSumoBannerPlanCount = 0,
}) => {
  const { t } = useTranslationApp();
  const { currentTypeOfPlan, isTypeOfPlansLoaded } = usePlanType();

  if (!isTypeOfPlansLoaded) {
    return null;
  }

  return (
    <Box
      sx={{
        pt: 4,
        pb: showAppSumoCreditsBanner ? 2 : 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        px: {
          md: 4,
          xs: 3,
        },
        background: "background.paper",
      }}
    >
      <Box
        sx={{
          maxWidth: "md",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 2,
        }}
      >
        <TitlePage
          align="center"
          sx={{
            color: "background.paperContrastText",
          }}
        >
          {getPricingHeroTitle(currentTypeOfPlan, t)}
        </TitlePage>
      </Box>
      {showAppSumoCreditsBanner ? (
        <AppSumoCreditsStackBanner t={t} planCount={appSumoBannerPlanCount} />
      ) : null}
    </Box>
  );
};

export default PricingHero;
